module.exports = __webpack_public_path__ + "static/media/Agriculture-and-Agri-Food-Canada.a89182fd.png";